import { FormControl } from "@angular/forms";
import { AddressService } from "../../../app/_core/services/address.service";
import { take } from "rxjs/operators";

export function MobileValidator(control: FormControl) {
	if (control.value && control.value !== "") {
		const number = control.value.replace(/[^0-9]/g, "");
		if (number.length === 10) {
			if (number === "0400000000" || !number.match(/^(04|05)\d{8}$/)) {
				return {
					validateMobile: {
						valid: false,
						message: "Number should be valid"
					}
					// tslint:disable-next-line:indent
				};
			} else {
				return null;
			}
		} else {
			return {
				validateMobile: {
					valid: false,
					message: "Number should be 10 digits"
				}
				// tslint:disable-next-line:indent
			};
		}
	} else {
		return null;
	}
}

export function CodeValidator(control: FormControl) {
	if (control.value && control.value !== "") {
		const number = control.value.replace(/[^0-9]/g, "");
		if (number.length === 6) {
			if (number === "000000") {
				return {
					validateCode: {
						valid: false,
						message: "Code should be valid"
					}
				};
			} else {
				return null;
			}
		} else {
			return {
				validateCode: {
					valid: false,
					message: "Code should be 6 digits"
				}
			};
		}
	} else {
		return null;
	}
}
